function Icon({ icon, className, ...rest }) {
  return (
    <span className={`icon ${className ? className : ''}`} {...rest}>
      {icon}
    </span>
  );
}

export default Icon;
